import axios from "axios";

/**
 *
 * @param {unknown} error
 * @return {string}
 */
export default function getErrorMessage(error) {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      if (error.response.data) {
        if (error.response.data.message) {
          return error.response.data.message;
        }
      }
    }
    return error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  if (typeof error.message === "string") {
    return error.message;
  }

  return JSON.stringify(error);
}
